import { useId, useState, type ReactNode } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { EASE, DURATION } from './motion';

interface TooltipProps { content: string; children: ReactNode; }

/** A small, non-blocking explanation layer for controls and disabled actions. */
export function Tooltip({ content, children }: TooltipProps) {
  const [visible, setVisible] = useState(false);
  const id = useId();
  const show = () => setVisible(true);
  const hide = () => setVisible(false);
  return (
    <span className="ui-tooltipAnchor" tabIndex={0} aria-describedby={visible ? id : undefined} onMouseEnter={show} onMouseLeave={hide} onFocus={show} onBlur={hide}>
      {children}
      <AnimatePresence>
        {visible && (
          <motion.span
            id={id}
            className="ui-tooltip"
            role="tooltip"
            initial={{ opacity: 0, y: 4, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 4, scale: 0.95 }}
            transition={{ duration: DURATION.fast, ease: EASE }}
          >
            {content}
          </motion.span>
        )}
      </AnimatePresence>
    </span>
  );
}
